import React from "react";

const Price = ({ minPrice, maxPrice }) => {
  if (!minPrice && !maxPrice) return null;

  return (
    <li className='calc-settings__list-item calc-price'>
      <div className='calc-settings-price'>
        <p className='calc-settings__list-item-title'>Цена за штуку:</p>
        <p className='calc-settings-price-descr'>
          Итоговая цена зависит от общей стоимости заказа. <br /> Точную цену
          можно узнать в корзине.
        </p>
      </div>
      <div className='calc-settings__list-item-setting settings-price'>
        {maxPrice === undefined ? `От ${minPrice} ₽` : `${minPrice} - ${maxPrice} ₽`}
      </div>
    </li>
  );
};

export default Price;
